var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoovLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4648 0.0295067C42.8263 0.0295067 55 11.9213 55 26.9277C55 41.9341 42.8263 53.826 27.4648 53.826C12.1032 53.826 0 42.0046 0 26.9277C0 11.8509 12.1032 0.0295067 27.4648 0.0295067ZM27.4648 44.127C36.8085 44.127 44.1708 36.5534 44.1708 26.9277C44.1708 17.3021 36.8085 9.72843 27.4648 9.72843C18.121 9.72843 10.8292 17.3021 10.8292 26.9277C10.8292 36.5534 18.121 44.127 27.4648 44.127Z",
    fill: "#316FF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20C24.4686 20 22 22.3729 22 25.2863C22 29.4289 26.9821 33.7067 27.1962 33.8879C27.2825 33.9604 27.393 34 27.5 34C27.607 34 27.7175 33.9637 27.8038 33.8912C28.0144 33.71 33 29.4322 33 25.2895C33 22.3729 30.5314 20.0033 27.5 20.0033V20ZM27.5 28.1667C25.8151 28.1667 24.4444 26.8583 24.4444 25.25C24.4444 23.6417 25.8151 22.3333 27.5 22.3333C29.1849 22.3333 30.5556 23.6417 30.5556 25.25C30.5556 26.8583 29.1849 28.1667 27.5 28.1667Z",
    fill: "#FF1010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoovLogo2);
export default __webpack_public_path__ + "static/media/loov-logo-2.158c76391be76ba7b156af71aca5b484.svg";
export { ForwardRef as ReactComponent };